import { H1, H2 } from "../../../../components/text/headings";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Fade,
  Flex,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useGetSupplierOverviewData } from "../../../../hooks/query/emissions-insight/emissions-insights-query";
import SupplierFiltersCatQualityYear from "../supplier-components/SupplierFiltersCatQualityYear";
import * as React from "react";
import EngagementCards from "./components/EngagementCards";
import DataQuality from "../../SupplierReports/components/SuppliersDataReport/components/DataQuality";
import { SupplierEngagementGrid } from "../../SupplierReports/components/SuppliersDataReport/components/SupplierEngagement/components";
import { ArrowLeft, ChartDonut, ListBullets } from "@phosphor-icons/react";
import { ToggleButton } from "../supplier-components/SupplierCards";
import TrendVisual from "./components/TrendVisual";
import SupplierListVisual from "./components/SupplierListVisual";
import { routes } from "../../../../config";
import { useNavigate } from "react-router-dom";

const SupplierEngagement = () => {
  const toast = useToast();
  const navigate = useNavigate();

  const [currentYearData, setCurrentYearData] = useState(null);
  const [previousYearData, setPreviousYearData] = useState(null);

  const [filters, setFilters] = useState();

  const handleEmissionsError = (error, year) => {
    if (error?.response?.status === 404) {
      toast({
        title: "Report not available for year " + year,
        description: "The emissions report for this year is not available.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
    } else {
      toast({
        title: "Error fetching current year emissions data",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const { data: overviewData, isFetching } = useGetSupplierOverviewData(
    [filters?.year, filters?.year - 1],
    filters?.categories,
    filters?.dataQuality,
    null,
    {
      onError: (error) => handleEmissionsError(error, filters?.year),
      cacheTime: 60, // 1 minute
    }
  );
  useEffect(() => {
    if (overviewData) {
      setCurrentYearData(overviewData[filters?.year]);
      setPreviousYearData(overviewData[filters?.year - 1]);
    }
  }, [overviewData, filters?.year]);

  return (
    <Flex direction="column" gap={2} mx="10%" mt={8}>

      <Flex onClick={() => navigate(routes.reportingPortalSupplierInsights)} align="center" gap={2} cursor="pointer">
        <ArrowLeft size={22} color="#85C22A" />
        <Text>Value Chain</Text>
      </Flex>

      <H1 fontSize="heading.xl">Supplier Engagement</H1>

      <SupplierFiltersCatQualityYear
        filters={filters}
        setFilters={setFilters}
        showFilters={["year", "quality", "category"]}
      />

      <EngagementCards currentYearData={currentYearData} previousYearData={previousYearData} isLoading = {isFetching} />

      <EngagementList filters={filters} setFilters={setFilters} />
      <Trends filters={filters} setFilters={setFilters} />
    </Flex>
  );
};

const Trends = ({filters, setFilters}) => {
  const [selectedViewType, setSelectedViewType] = useState("table");

  return (
    <Box my={2}>
      <Accordion allowToggle>
        <AccordionItem>

          <AccordionButton>
            <H2 fontSize="body.2xl">Trends</H2>
            <AccordionIcon mr={0} ml="auto" />
          </AccordionButton>

          <AccordionPanel mt={4}>
            <Flex width="fit-content" alignSelf="flex-end" my={2}>
              <ToggleButton
                options={[
                  { label: "Table", value: "table", icon: <ListBullets size={18} /> },
                  { label: "Visual", value: "visual", icon: <ChartDonut size={18} /> },
                ]}
                selected={selectedViewType}
                setSelected={setSelectedViewType}
              />
            </Flex>
            <Fade in={selectedViewType === "table"} unmountOnExit>
              <SupplierEngagementGrid categoryId={null} />
            </Fade>
            <Fade in={selectedViewType === "visual"} unmountOnExit>
              <TrendVisual setFilters={setFilters} filters={filters} />
            </Fade>
          </AccordionPanel>

        </AccordionItem>
      </Accordion>

    </Box>
  );
};

const EngagementList = ({filters, setFilters}) => {
  const [selectedViewType, setSelectedViewType] = useState("table");

  return (
    <Flex direction="column" mt={8}>

      <Flex width="fit-content" alignSelf="flex-end" my={2}>
        <ToggleButton
          options={[
            { label: "Table", value: "table", icon: <ListBullets size={18} /> },
            { label: "Visual", value: "visual", icon: <ChartDonut size={18} /> },
          ]}
          selected={selectedViewType}
          setSelected={setSelectedViewType}
        />
      </Flex>
      <Fade in={selectedViewType === "table"} unmountOnExit>
        <DataQuality pageSize={10} />
      </Fade>
      <Fade in={selectedViewType === "visual"} unmountOnExit>
        <SupplierListVisual filters={filters} setFilters={setFilters} />
      </Fade>
    </Flex>
  );
}

export default SupplierEngagement;
